<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jF6Tzt/tc-custom/9780369726384.jpg?1743854144023" alt="This image is the cover for the book Awakened by the Wild Billionaire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Awakened by the Wild Billionaire
      </h1>
      <p class="bookDescription body article font2">
        <b>She’s shy. He’s <i>wild</i>! Opposites attract in Bella Mason’s sexy debut romance for Harlequin Presents!</b><br/><br/> A chance meeting…<br/><i>Leads to an extraordinary encounter</i><br/><br/> Colliding with a masked stranger at a glamorous Melbourne ball sends shy Emma Brown’s pulse skyrocketing. And that’s <i>before</i> he introduces himself as Alexander Hastings, the ultrarich CEO with a wild side, which puts him way out of her league!<br/><br/> Only Alex’s focus is <i>all</i> on Emma. And just this once, she steps out of her family’s shadow and into the billionaire’s penthouse. Their unrivaled connection awakens in Emma a longing for the one thing she’s never allowed herself to want and the one thing Alex can’t offer her… Forever!<br/><br/><b>From Harlequin Presents:<i> Escape to exotic locations where passion knows no bounds.</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bella Mason
      </h2>
      
      <p class="authorDescription body article">Bella Mason has been a bookworm from an early age. She has been regaling people with stories from the time she discovered she could hold the dinner table hostage with her re-imagined fairy tales. After earning a degree in Journalism, she rekindled her love of writing and she now writes full time. When she isn&#39;t imagining dashing heroes and strong heroines, she can be found exploring Melbourne, with her nose in a book or lusting after fast cars.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7dc2e259